import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20manga%20library%20atmosphere%20with%20warm%20ambient%20lighting%2C%20soft%20bookshelf%20background%2C%20cozy%20reading%20space%20with%20warm%20coral%20and%20amber%20tones%2C%20abstract%20stylized%20manga%20panel%20elements%20floating%2C%20dreamy%20atmosphere%2C%20editorial%20quality%2C%20clean%20modern%20aesthetic&width=1600&height=900&seq=hero-bg-manga&orientation=landscape"
          alt="女神漫画 - 韩漫日漫国漫在线漫画阅读平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          {/* Left - Text */}
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium tracking-wide text-background-50 bg-primary-500/80 rounded-full mb-4">
              {heroData.tag}
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight">
              {heroData.h1}
            </h1>

            <p className="mt-3 text-base md:text-lg text-background-100 font-medium">
              {heroData.slogan}
            </p>

            <p className="mt-5 text-sm md:text-base text-background-200 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              {heroData.intro}
            </p>

            {/* Stats */}
            <div className="mt-6 flex flex-wrap justify-center lg:justify-start gap-6 md:gap-10">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-300 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="mt-7 flex flex-col sm:flex-row justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.anchor}
                className="inline-flex items-center justify-center px-7 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-book-read-line mr-2 text-base w-5 h-5 flex items-center justify-center" />
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.anchor}
                className="inline-flex items-center justify-center px-7 py-3 border border-background-50/40 text-background-50 font-medium text-sm rounded-full hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-smartphone-line mr-2 text-base w-5 h-5 flex items-center justify-center" />
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          {/* Right - Visual */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[340px] md:h-[460px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20Korean%20webtoon%20style%20illustration%20of%20elegant%20female%20character%20reading%20a%20book%20surrounded%20by%20floating%20magical%20manga%20pages%2C%20warm%20coral%20and%20soft%20peach%20color%20palette%2C%20dreamy%20atmosphere%2C%20delicate%20linework%2C%20manhwa%20art%20style%2C%20ethereal%20glowing%20effects%2C%20clean%20composition%2C%20editorial%20quality&width=680&height=920&seq=hero-visual-manga&orientation=portrait"
                alt="女神漫画 · 下拉式在线漫画阅读体验"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}